<template>
  <el-dialog v-model="formVisible" title="分派" @close="close" width="40%">
    <div class="numberClick">
      <h-anchor class="anchor" :idList="idList">
        <el-form
          ref="ruleFormRef"
          :model="ruleForm"
          :rules="rules"
          :disabled="isDisabled"
          label-width="120px"
          class="userForm"
        >
          <div id="one">
            <div v-if="tableSelection.length === 0" class="formTitle">
              <span></span>事件详情
            </div>
            <sqDetail
              v-if="tableSelection.length === 0"
              :form="userFormData"
            ></sqDetail>
          </div>
          <div id="two" style="height: 550px">
            <div class="formTitle"><span></span>事件分派</div>
            <el-row>
              <el-col :span="24">
                <el-form-item label="分派指定角色" prop="roleId">
                  <el-select
                    v-model="ruleForm.roleId"
                    clearable
                    placeholder="分派指定角色"
                    @change="selectZd(false)"
                  >
                    <el-option
                      v-for="item in optionsJsList"
                      :key="item.roleId"
                      :label="item.roleName"
                      :value="item.roleId"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="分派指定用户" prop="userId">
                  <el-select
                    v-model="ruleForm.userId"
                    placeholder="分派指定用户"
                  >
                    <el-option
                      v-for="item in optionsYhList"
                      :key="item.userId"
                      :label="
                        item.deptName + '__' + item.name + '__' + item.username
                      "
                      :value="item.userId"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </h-anchor>
    </div>
    <template #footer>
      <template v-if="!isDisabled">
        <h-button v-if="status === 2" @click="Previous()">上一条</h-button>
        <h-button type="primary" @click="submitForm(ruleFormRef)"
          >保存</h-button
        >
        <h-button @click="formVisible = false">取消</h-button>
        <h-button v-if="status === 2" @click="Next()">下一条</h-button>
      </template>
    </template>
  </el-dialog>
</template>
<script >
import { defineComponent, reactive, toRefs, watchEffect, ref } from "vue";

import { getRoleList } from "@/api/system/role.js";
import { queryUserList } from "@/api/user.js";
import { eventassign } from "@/api/eventManagement/eventManagementApi.js";
import { ElMessage } from "element-plus";
import _ from "lodash";
import util from "@util/js";
import sqDetail from "./sqDetail.vue";
export default defineComponent({
  name: "",
  components: { sqDetail },
  props: {
    tableSelection: {
      type: Array,
      default: () => [],
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: () => ({}),
    },
    status: {
      type: Number,
      default: 1, // 1 添加；2 编辑；3 只读
    },
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["update:modelValue", "submit"],
  setup(props, context) {
    const ruleFormRef = ref();
    // const validate = new Validate(ruleFormRef.value);
    const state = reactive({
      formVisible: false,
      userFormData: {},
      ruleForm: { roleId: "" },
      optionsJsList: [],
      optionsYhList: [],
      ruleFormBack: {},
      rules: {
        userId: [
          {
            required: true,
            message: "请选择",
            trigger: "blur",
          },
        ],
      },
      userDeptId: util.getStorage("userDeptId"),
      options: [],
      idList: [
        { name: "事件内容", id: "one", icon: "icon-shenfenzheng" },
        { name: "事件分派", id: "two", icon: "icon-invite" },
      ],
    });
    state.ruleFormBack = _.cloneDeep(state.ruleForm);
    // state.ruleForm
    const refData = toRefs(state);
    // 监听弹框显示因此
    watchEffect(() => {
      state.formVisible = props.modelValue;
      state.userFormData = props.form;
    });
    watchEffect(() => {
      context.emit("update:modelValue", state.formVisible);
    });

    // 保存表单数据
    const submitForm = (formEl) => {
      if (!formEl) return;
      formEl.validate(async (valid) => {
        if (valid) {
          let res = {};
          if (props.status === 1) {
            state.ruleForm.eventIds = props.tableSelection.map(
              (item, index) => {
                return item.id;
              }
            );
          } else {
            state.ruleForm.eventIds = [state.userFormData.id];
          }

          res = await eventassign(state.ruleForm);
          if (res.code === 0) {
            state.formVisible = false;
            ElMessage.success("分配成功");
            state.formVisible = false;
            context.emit("submit");
          }
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };
    const close = () => {
      state.ruleForm = _.cloneDeep(state.ruleFormBack);
    };
    const selectZd = async (changeRole) => {
      if (changeRole) {
        const res = await getRoleList();
        state.optionsJsList = res.roleList;
      }
      const params = {
        // limit: 20,
        // page: 1,
        allowpage: true,
        hasSonDept: true,
        deptId: state.userDeptId,
        roleId: state.ruleForm.roleId ? state.ruleForm.roleId : "",
      };
      const ress = await queryUserList(params);
      state.optionsYhList = ress.page.list;
    };
    selectZd(true);
    const Previous = () => {
      let inde;
      props.tableData.forEach((item, index) => {
        if (item.id === state.userFormData.id) {
          inde = index;
        }
      });
      for (let index = 0; index < props.tableData.length; index++) {
        const element = props.tableData[index];
        if (element.state === "1" && index < inde) {
          state.userFormData = element;
          return;
        }
      }
      ElMessage({
        type: "warning",
        message: "没有上一条了",
      });
    };
    const Next = () => {
      let inde;
      props.tableData.forEach((item, index) => {
        if (item.id === state.userFormData.id) {
          inde = index;
        }
      });
      for (let index = 0; index < props.tableData.length; index++) {
        const element = props.tableData[index];
        if (element.state === "1" && index > inde) {
          state.userFormData = element;
          return;
        }
      }
      ElMessage({
        type: "warning",
        message: "没有下一条啦",
      });
    };

    return {
      ...refData,
      submitForm,
      Previous,
      Next,
      close,
      ruleFormRef,
      selectZd,
    };
  },
});
</script>
<style  lang='scss' scoped >
.numberClick {
  max-height: 600px;
  overflow: auto;
  .anchor {
    max-height: 550px;
  }
}
.userForm {
  width: 100%;
  max-height: 500px;
  height: 500px;
}
.formTitle {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  span {
    width: 3.5px;
    height: 16px;
    background-color: #5584ff;
    margin-right: 10px;
  }
}
.margLeftLabel {
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>